import { WidgetMenuItems, isStandardMenuItem, isStaticImageMenuItem, isStaticTextMenuItem, isOpenURLMenuItem } from "@xapp/stentor-chat-widget";
import React, { FC } from "react";
import "./ChatMenu.scss";
import ChatMenuItem from "./ChatMenuItem";

import { useOpenUrlCallback } from "../../hooks/useOpenUrlCallback";
import { useSelector } from "react-redux";
import { ChatState, VisualState } from "../../store/ChatState";
import { useChatDispatch } from "../../utils/useChatDispatch";

export interface ChatMenuProps {
    /**
     * Menu items
     */
    readonly items: readonly WidgetMenuItems[];

    readonly tabIndex?: string;
    /**
     * Direction the drawer opens from, defaults to "bottom"
     */
    readonly openFrom?: "left" | "right" | "bottom";
    /**
     * Is the menu opened
     */
    readonly opened: boolean;
    /**
     * This will only return for the clickable labels.
     * 
     * @param label 
     */
    onItemClick(label: string): void;
}

const ChatMenu: FC<ChatMenuProps> = props => {
    const { items, opened } = props;
    const openFrom = props.openFrom || "bottom"

    const handleOpenUrl = useOpenUrlCallback();
    const chatDispatch = useChatDispatch();
    const visuals = useSelector<ChatState, VisualState>((state) => state.visuals);

    return (
        <div className={`chat-menu-${openFrom} ${opened ? `chat-menu-${openFrom}--opened` : `chat-menu-${openFrom}--closed`}`}>
            {
                items.map((item, i: number) => {
                    if (isStandardMenuItem(item)) {
                        return <ChatMenuItem
                            key={i}
                            onClick={props.onItemClick}
                            label={item.label}
                            subtitle={item.subtitle}
                        />;
                    } else if (isStaticImageMenuItem(item)) {
                        return (
                            <div key={i} className="chat-menu-item-static" >
                                <img style={{
                                    maxHeight: "100%",
                                    maxWidth: "auto"
                                }} src={item.imageUrl} alt={"Menu Item"} />
                            </div>);
                    } else if (isStaticTextMenuItem(item)) {
                        return (
                            <div key={i} className="chat-menu-item-static-text">
                                <div>
                                    <div>{item.title}</div>
                                    <div className="chat-menu-item-static-text--body">{item.body}</div>
                                </div>
                            </div>
                        );
                    } else if (isOpenURLMenuItem(item)) {
                        return <button key={i} className="chat-menu-item" onClick={handleOpenUrl.bind(this, item.url, chatDispatch, visuals, item.behavior)}>{item.text}</button>
                    }
                    return <p>Unknown</p>;
                })
            }
        </div >);
}

export default ChatMenu;